import React from "react";
import Expandable from "./Expandable";

const faqs = [
  {
    q: "How does the blocking work?",
    a: "Blocking works by checking your visited URLs. These URLs are not stored; the app only checks for blocked sites or keywords and closes them if detected.",
  },
  {
    q: "Where is my data stored? How?",
    a: "We don't store or collect browsing data. Blocking-related data is stored locally on your computer.",
  },
  {
    q: "What’s the difference between the free and pro version?",
    a: "The Pro version offers stronger, harder-to-bypass blocking, customizable blocklists for sites and keywords, and upcoming features like whitelists and fines.",
  },
  {
    q: "Is the app compatible with all browsers and devices?",
    a: "The app is compatible with Mac computers, with Windows support coming soon. It works with Chrome, Edge, and Safari browsers. In the Pro version, unsupported browsers are fully blocked.",
  },
  {
    q: "I am able to bypass the app, what should I do?",
    a: "If you're able to bypass the app, try the Pro version, which blocks keywords for stronger protection. You can also add your own keywords. We're also working on new features to make blocking harder. If you need a specific bypass blocked, please reach out at blockforeverapp@gmail.com.",
  },
  {
    q: "I have another question",
    a: "For any other questions or assistance, please contact us at blockforeverapp@gmail.com",
  },
];

export default function Faq() {
  return (
    <div>
      <h2> Frequently Asked Questions </h2>
      <div className="card faqCard">
        {faqs.map((faq) => (
          <div className="mt-24">
            <Expandable question={faq.q} answer={faq.a} />
          </div>
        ))}
      </div>
    </div>
  );
}
